var initSlick = function () {
    $('.slider').slick({
        infinite: true,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 500,
        fade: true,
        cssEase: 'linear'
    }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
        return false;
    });

    // const sliderTp = $('.slider-tp');
    // var scrollCount = null;
    // var scroll = null;
    // let currentSlideGlobal = 1;
    //
    // sliderTp.slick({
    //     infinite: false,
    //     dots: false,
    //     arrows: false,
    //     speed: 700,
    //     slidesToShow: 1
    // }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
    //     currentSlideGlobal = currentSlide + 1;
    //     $('.carousel__counter--current').text('0' + currentSlideGlobal);
    // });
    //









    // init controller
    // var controller = new ScrollMagic.Controller();
    //
    // var isSticky = false;
    //
    // var scene = new ScrollMagic.Scene({triggerElement: ".carousel", offset: ($('.carousel').height() / 2)})
    //     .on('start', function (e) {
    //         fIsSticky();
    //     })
    //     .addTo(controller);
    //
    //
    // $(window).on('wheel', (function (e) {
    //     if (isSticky) {
    //         if (((currentSlideGlobal < $(".slider-tp > .slick-list > .slick-track > .slick-slide").length) && e.originalEvent.deltaY > 0) || ((currentSlideGlobal > 1) && e.originalEvent.deltaY < 0)) {
    //
    //             clearTimeout(scroll);
    //             scroll = setTimeout(function () {
    //                 scrollCount = 0;
    //             }, 200);
    //             if (scrollCount) return 0;
    //             scrollCount = 1;
    //
    //
    //             if (e.originalEvent.deltaY < 0) {
    //                 sliderTp.slick('slickPrev');
    //             } else {
    //                 sliderTp.slick('slickNext');
    //             }
    //
    //         } else {
    //             fIsNotSticky();
    //         }
    //     }
    // }));

    $(".slick-arrow").text("");

    // function fIsSticky() {
    //     isSticky = true;
    //     $("body").addClass("overflowy--h");
    // }
    //
    // function fIsNotSticky() {
    //     isSticky = false;
    //     $("body").removeClass("overflowy--h");
    // }
};


